<template>
  <div class="mx-5">
    <div
      v-for="(commentary, index) in postList"
      :key="problemId + 'post' + index"
      :class="{ 'mb-6': index !== postList.length - 1 }"
    >
      <CommentaryPanel
        :bindCommentary="bindCommentary"
        :commentary="commentary"
        :icon="'contact_support'"
        :panelIndex="index"
        :selectedIndex="commentaryPageStatePresenter.postCommentarySelectedList.value[commentary.type] ?? 0"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted } from 'vue'

import CommentaryPanel from './children/CommentaryPanel.vue'

import { useCommentaryPageStatePresenter } from '@/presentation/composables/commentary/useCommentaryPageStatePresenter'
import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useProblemDescriptionPresenter } from '@/presentation/composables/problem/useProblemDescriptionPresenter'
import { useProblemStatePresenter } from '@/presentation/composables/problem/useProblemStatePresenter'

export default defineComponent({
  components: { CommentaryPanel },
  setup(props, ctx) {
    const commentaryPageStatePresenter = useCommentaryPageStatePresenter()
    const { displayLanguage, programLanguage } = useConfigStatePresenter()
    const { problemId } = useProblemStatePresenter()
    const problemDescriptionPresenter = useProblemDescriptionPresenter()

    const postList = computed(() =>
      problemDescriptionPresenter.problemDescription.value.commentaries.filter(
        (c: { pattern: string }) => c.pattern == 'post'
      )
    )

    const bindCommentary = async (panelIndex: number, selectedIndex: number, value: string) => {
      const target = postList.value[panelIndex]
      commentaryPageStatePresenter.bindCommentary(
        displayLanguage.value,
        problemId.value,
        target.pattern,
        target.type,
        value,
        selectedIndex
      )
      wait5mMathJax()
    }

    const wait5mMathJax = () => {
      setTimeout(() => {
        // @ts-ignore
        // eslint-disable-next-line no-undef
        MathJax.typeset()
      }, 100)
    }

    onMounted(() => {
      wait5mMathJax()
      commentaryPageStatePresenter.openCommentaryPage(
        programLanguage.value,
        displayLanguage.value,
        problemId.value,
        'post',
        postList.value
      )
    })

    return {
      postList,
      bindCommentary,
      commentaryPageStatePresenter,
      problemId
    }
  }
})
</script>

<style lang="postcss" scoped></style>
